import React from 'react'
import { useStateContext } from '../Context/ContextProvider';

function PrintSaleInvoice(props) {
  const {weburl,currency}=useStateContext();
const checkfreshinvoice='1';
const decideCustomer=localStorage.getItem('creditcash')?localStorage.getItem('creditcash'):'1';
  const styles = {
    container: {
      textAlign: 'right',
      marginRight: '10px',
      marginBottom: '4px',
      padding: '10px',
    },
    centered: {
     
      textAlign: 'center',
      fontSize: '12px',
      fontFamily: 'Times New Roman',
      border: '1px solid gray',
    },
    h1: {
      display: 'inline-block',
      fontSize: '12px',
      fontFamily: 'Times New Roman',
    },
    table: {
      borderCollapse: 'collapse',
      width: '100%',
    },
    th: {
      border: '1px solid black',
     
      fontSize: '13px',
      fontFamily: 'Times New Roman',
    },
  
   
   
  };
  
 const pos=localStorage.getItem('pos') || '0';
 
  
  const total = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.qty*item.unitsaleprice);
    return isNaN(value) ? acc : acc + value;
  }, 0);
  const subtotaldiscount = props.data.letter.reduce((acc, item) => {
    const value = parseFloat(item.subtotaldiscount);
    return isNaN(value) ? acc : acc + value;
  }, 0);
    const totalqty = props.data.letter.reduce((acc, item) => {
      const value = parseFloat(item.qty);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    const totalweight = props.data.letter.reduce((acc, item) => {
      const value = parseFloat(item.qty*item.weight);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    const totalpack = props.data.letter.reduce((acc, item) => {
      const value = Math.floor(item.qty/item.pack_size);
      return isNaN(value) ? acc : acc + value;
    }, 0);
    const totalrate = props.data.letter.reduce((acc, item) => {
      const value = parseFloat(item.unitsaleprice);
      return isNaN(value) ? acc : acc + value;
    }, 0);
  
  if(pos==='0')
  {


    return(

<div id='printablearea'>
<div style={styles.container}>
        <center>
 <img style={{height:'80px',width:'80px'}} src={`${weburl}${
 props.data.detail.logo}`} alt="sory"/>
      </center>
      <div style={{textAlign:'center'}}>
        <h3 style={{ textAlign: 'center' ,marginBottom:'-10px'}} >
        {props.data.detail.slogan_heading} 
        </h3>
        <h5 style={{ textAlign: 'center' ,marginBottom:'-10px'}} >
       
        Ph:+92 300-6994971
        </h5>
       
        <p  style={{ textAlign: 'center',marginBottom:'-10px' }}>{props.data.detail.slogan_subheading}</p>
        <p style={{textAlign:'center'}}>
          Invoice No=<span >{props.data.invoiceno}</span><br></br>
          Time&Date=<span style={{fontSize:'15px'}}>{props.data.printingtime}-{props.data.manualdate}</span>
        </p>
      </div>
      <table style={{...styles.table,marginTop:'-8px'}}>
        <thead>
          <tr>
          <th style={{...styles.th}}>Sr</th>
          <th style={{...styles.th}}>Item</th>
            <th style={{...styles.th}}>Qty</th>
          
            <th style={{...styles.th}}>Rate</th>
           
            <th style={{...styles.th}}>Total</th>
          </tr>
        </thead>
        <tbody id="printcartfortsp100">
        
        {props.data.letter && props.data.letter.map((item, index)=> (
        
        <tr key={index}>
         
                 <td style={{...styles.centered}}>  {++index}</td>
                        <td  style={{...styles.centered}}>{item.name}</td>

                        <td style={{...styles.centered}}>{item.qty}</td>

              
                          
                          <td  style={{...styles.centered}}>{item.unitsaleprice}</td>
                    
                        <td  style={{...styles.centered}}>{item.qty*item.unitsaleprice}</td>
                       
                    </tr>
))}

       
        </tbody>
      </table>
   
      <div style={{textAlign: 'center',marginTop:'4px'}}>
      <b>Total: <span >{currency}{parseFloat(props.data.grandtotal).toFixed(2)}</span></b>
 
    </div>
    <div style={{textAlign: 'center',display:parseFloat(props.data.shipping).toFixed(2)<='0.00'?'none':''}}>
      <b>Shipping: <span>{currency}{parseFloat(props.data.shipping).toFixed(2)}</span></b>
        
    </div>
    <div style={{textAlign: 'center'}}>
      <b>GST/HST: <span>{currency}{parseFloat(props.data.salestax).toFixed(2)}</span></b>
        
    </div>
    <div style={{textAlign: 'center'}}>
      <b>Total With GST: <span>{currency}{parseFloat((parseFloat(props.data.grandtotal)+parseFloat(props.data.salestax)+parseFloat(props.data.shipping))).toFixed(2)}</span></b>
        
    </div>
    <div style={{textAlign: 'center',display:parseFloat(props.data.discount).toFixed(2)<='0.00'?'none':''}}>
      <b> Discount: <span >{currency}{parseFloat(props.data.discount).toFixed(2)}</span></b>
      
    </div>
    
     <div style={{textAlign: 'center',display:parseFloat(props.data.discount).toFixed(2)<='0.00'?'none':''}}>
      <b> Total After Discount: <span >{currency}{parseFloat(parseFloat(props.data.remainingbill)+parseFloat(props.data.salestax)).toFixed(2)}</span></b>
      
    </div>
   
   
    {checkfreshinvoice===props.data.indicator?
    decideCustomer==='1'?
     <div><div style={{textAlign: 'center'}}>
      <b>      Payment: <span >{currency}{parseFloat(props.data.entercash).toFixed(2)}</span></b>

    </div>
    <div style={{textAlign: 'center'}}>
      <b>      Return: <span >{currency}{parseFloat(parseFloat(props.data.entercash)-(parseFloat(props.data.recovery)+parseFloat(props.data.payment))).toFixed(2)}</span></b>

    </div></div>:''
    :<div>
<div style={{textAlign: 'center'}}>
      <b>      Paid Amount: <span >{currency}{parseFloat((parseFloat(props.data.recovery)+parseFloat(props.data.payment))).toFixed(2)}</span></b>

    </div>

    </div>
  }
  <center>
<span  style={{marginTop: '-10px',fontFamily: 'Noto Nastaliq Urdu, cursive' }}> <div style={{marginBottom: '8px'}}>
     <span style={{fontSize:'18px',fontweight:'bold'}}>Thanks for having meal</span> 
    </div> 😊 <br/> </span>
</center>
 
    
      
    </div>
</div>



    )
        


  }
  
  else{

  

  return (
  <div id='printablearea' style={{ width: '100%' }}>
<div  style={{float: 'center',backgroundColor: 'white',borderTop: '1px solid black',display: 'flex',justifyContent: 'space-between',marginTop: '-10px'}}>
  
   <div>
     <h1 style={{marginBottom: '-1px'}} >{props.data.detail.slogan_heading} </h1>
     <center><b><span style={{textDecoration: 'underline'}}> {props.data.detail.slogan_subheading}</span></b>
     <br>
     </br>
    
     Ph:+92 341 4701626
     </center>
     
    
   </div>

    <div style={{textAlign:'right',marginRight: '10px',marginBottom:'4px',padding: '10px'}}>
   
 <img style={{height:'80px',width:'80px'}} src={`${weburl}${
 props.data.detail.logo}`} alt="img"/>
 
   </div>
   
</div>

<div style={{display: 'flex',justifyContent: 'space-between',paddingLeft: '0px',paddingRight: '0px'}}>

  <div style={{border:'1px solid black',borderRadius: '8px',height:'80px',padding: '10px',width: '350px'}}>
    <div style={{marginBottom: '1px',fontSize:14}}>
     <b>Name</b>:<span style={{fontSize:'16px',fontweight:'bold'}}>{props.data.customer.name}</span> 
    </div>
    
  <div style={{marginBottom: '1px',fontSize:14}}>
   <b>Address</b>:<span >{props.data.customeraddress}</span>
    </div>
     <div style={{marginBottom:'1px',fontSize:14}}>
    <b>Phone</b>:<span>{props.data.customer.phone} </span>
    </div>
    <div style={{marginBottom:'1px',fontSize:14}}>
    <b>Id Card</b>:<span>{props.data.customer.cnic} </span>
    </div>
    <div style={{marginBottom:'1px',fontSize:14}}>
    <b>Status</b>:<span>{props.data.customer.secondname==='0'?'Filer':'Non-Filer'} </span>
    </div>


  </div>
  <div style={{border:'1px solid black',padding: '10px',width: '350px',borderRadius: '8px',height: '80px'}}>
    <div>
      <b>Salesman Name:</b><span >{props.data.salesman.name}</span> <br></br>
              <b>Salesman Phone:</b><span >{props.data.salesman.phone}</span><br/>
              
    </div>
    <div >
     
              <b>Invoice Date:</b><span >{props.data.manualdate}</span><br/>
             
    </div>
     <div >
     <b>Invoice</b>:<span >{props.data.invoiceno}</span> 
    </div>

    

     
  </div>
</div>

<div style={{paddingRight: '0px',paddingLeft: '0px',marginTop:'25px',border:'1px solid black',marginLeft: '0px',marginRight:'0px'}}>
     <table style={{width: '100%'}}>
        <thead >
              <tr>
                 <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Sr#</th>
                        <th  style={{textAlign: 'left',border: '1px solid #dddddd'}}>Item Name</th>

                        <th  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}} >Ctn</th>
                        <th  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}} >Pcs</th>
                        <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Qty</th>
                        <th  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>Unit</th>
                         <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Weight</th>

                          <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Rate</th>

                        <th   style={{textAlign: 'center',border: '1px solid #dddddd'}}>Sub Total</th>
                      
                        <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Discount</th>
                    
                        
                        <th  style={{textAlign: 'center',border: '1px solid #dddddd'}}> Total</th>
                      
                    </tr>

        </thead>

        <tbody id="printcartreciept">
        {props.data.letter && props.data.letter.map((item, index)=> (
        
        <tr key={index}>
         
                 <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{++index}</td>
                        <td  style={{textAlign: 'left',border: '1px solid #dddddd',width:'100px'}}>{item.name}</td>

                        <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>{Math.floor(item.qty/item.pack_size)}</td>
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>{(item.qty%item.pack_size)}</td>
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{item.qty}</td>
<td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>{item.unit}</td>
                         <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{(item.qty*item.weight).toFixed(2)}</td>

              
                          
                          <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{item.unitsaleprice}</td>
                    
                        <td   style={{textAlign: 'center',border: '1px solid #dddddd'}}>{(item.qty*item.unitsaleprice).toFixed(2)}</td>
                       
                     
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>
                          
                             {item.subtotaldiscount}</td>
                      <td   style={{textAlign: 'center',border: '1px solid #dddddd'}}>{parseFloat((item.qty*item.unitsaleprice)-(item.subtotaldiscount)).toFixed(2)}</td>

                    </tr>
))}


        </tbody>
      
<tfoot>
<tr >
                 <td  style={{textAlign: 'left',border: '1px solid #dddddd'}}></td>
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>Total</td>

                        <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>{totalpack.toFixed(2)}</td>
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}></td>

                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{totalqty.toFixed(2)}</td>
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}></td>
                         <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{totalweight.toFixed(2)}</td>

                          <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}>{totalrate.toFixed(2)}</td>
                          <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}></td>
                          <td  style={{textAlign: 'center',border: '1px solid #dddddd',display:'none'}}></td>

                          <td   style={{textAlign: 'center',border: '1px solid #dddddd'}}>{totalrate.toFixed(2)}</td>
                          <td   style={{textAlign: 'center',border: '1px solid #dddddd'}}>{parseFloat(parseFloat(total)).toFixed(2)}</td>
                       
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{subtotaldiscount.toFixed(2)}</td>
                     
                        <td  style={{textAlign: 'center',border: '1px solid #dddddd'}}>{parseFloat(parseFloat(total)-parseFloat(subtotaldiscount)).toFixed(2)}</td>
                        
                    </tr>

</tfoot>
    </table>


  </div>
  <div style={{float:'right',padding: '15px',display: 'flex',justifyContent: 'space-between',marginTop: '00px'}}>
    
          
        

          <div style={{width: '340px',height: '150px',padding: '20px',borderRadius: '10px'}}>
               
    <div style={{textAlign: 'right'}}>
      <b>Total Bill: <span >{currency}{parseFloat(props.data.grandtotal).toFixed(2)}</span></b>
 
    </div>
    <div style={{textAlign: 'right',display:parseFloat(props.data.discount).toFixed(2)<='0.00'?'none':''}}>
      <b> Discount: <span >{currency}{parseFloat(props.data.discount).toFixed(2)}</span></b>
      
    </div>
    <div style={{textAlign: 'right',display:parseFloat(props.data.shipping).toFixed(2)<='0.00'?'none':''}}>
      <b>Shipping: <span>{currency}{parseFloat(props.data.shipping).toFixed(2)}</span></b>
        
    </div>
   
    <div style={{textAlign: 'right',display:parseFloat(props.data.salestax).toFixed(2)<='0.00'?'none':''}}>
      <b>Total After Discount : <span>{currency}{parseFloat((parseFloat(props.data.grandtotal)+parseFloat(props.data.shipping)-parseFloat(props.data.discount))).toFixed(2)}</span></b>
        
    </div>
   
    <div style={{textAlign: 'right',display:parseFloat(props.data.salestax).toFixed(2)<='0.00'?'none':''}}>
      <b>Adv.Tax: <span>{currency}{parseFloat(props.data.salestax).toFixed(2)}</span></b>
        
    </div>
    
    
     <div style={{textAlign: 'right',display:parseFloat(props.data.discount).toFixed(2)<='0.00'?'none':''}}>
      <b> Net Amount: <span >{currency}{parseFloat(parseFloat(props.data.remainingbill)+parseFloat(props.data.salestax)).toFixed(2)}</span></b>
      
    </div>
   
   
    
    <div style={{textAlign: 'right'}}>
      <b>Pre Balance: <span>{currency}{parseFloat(props.data.pbalance).toFixed(2)}</span></b>
        
    </div>

    <div style={{textAlign: 'right'}}>
      <b>Total Bill: <span>{currency}{parseFloat(parseFloat(props.data.pbalance)+parseFloat(props.data.remainingbill)+parseFloat(props.data.salestax)).toFixed(2)}</span></b>
        
    </div>

     
     <div style={{textAlign: 'right'}}>
      <b>      Payment: <span >{currency}{parseFloat(parseFloat(props.data.recovery)+parseFloat(props.data.payment)).toFixed(2)}</span></b>

    </div>
   
    


      
     <div style={{textAlign: 'right'}}>
      <b> Curent Bills: <span style={{fontSize:'15px'}}>{currency}{parseFloat((parseFloat(props.data.grandtotal)-parseFloat(props.data.discount)+parseFloat(props.data.salestax)-(parseFloat(props.data.payment)+parseFloat(props.data.recovery))+parseFloat(props.data.pbalance)+parseFloat(props.data.shipping))).toFixed(2)}</span></b>
       
    </div>
          </div>
       </div>


  </div>

  
  
  )
        }
}

export default PrintSaleInvoice
